module.exports = __webpack_public_path__ + "img/physical-training.ecdd23bf.jpg";